import React from 'react';

import { CandidateListGroupingOptions } from 'constants/candidates';
import { toggle } from '@utils';
import { ICandidatesControls } from '../controls';
import { CandidateFilterSections } from './CandidateFilterSections';
import { CandidateSearch } from './CandidateSearch';
import { GroupByMenu } from './GroupByMenu';
import { ListFiltersDialog } from './ListFiltersDialog';
import { PositionList } from './PositionFilterChips';
import { ShowRejectedToggle } from './ShowRejectedToggle';

export const CandidateFiltersDialog: React.FC<ICandidatesControls> = ({
  data,
  filterOptions,
  view,
  activeFilterCount,
  isDefault,
  inactiveCount,
  onChange,
  onReset,
}) => (
  <ListFiltersDialog
    title="Candidates for your positions"
    activeFilterCount={activeFilterCount}
    isDefault={isDefault}
    onReset={onReset}
    search={
      <CandidateSearch
        fullWidth
        data={data}
        value={view.query}
        onChange={(query) => onChange({ query })}
      />
    }
    controls={
      <>
        <GroupByMenu
          options={CandidateListGroupingOptions}
          value={view.groupBy}
          onChange={(groupBy) => onChange({ groupBy })}
        />
        <ShowRejectedToggle
          checked={view.showRejected}
          count={inactiveCount}
          onChange={(showRejected) => onChange({ showRejected })}
        />
      </>
    }
  >
    <CandidateFilterSections
      {...filterOptions}
      selectedRegions={view.regions}
      selectedSeniorities={view.seniorities}
      selectedStatuses={view.statuses}
      onChange={onChange}
    />

    <PositionList
      positions={data}
      selectedIds={view.positionIds}
      onToggle={(id) => onChange({ positionIds: toggle(view.positionIds, id) })}
    />
  </ListFiltersDialog>
);
